<template>
  <div class="cigar-list">
    <UploadCustomize id="3" />
    <div class="table-search">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">添加商品</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          label="排序"
          type="index"
          align="center">
        </el-table-column>
        <el-table-column prop="madeName" label="名称" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.madeState">上架</span>
            <span v-else>下架</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span
              class="upShelves"
              v-if="!scope.row.madeState"
              @click="handleShelves(scope.row.id)"
            >上架</span>
            <span class="downShelves" v-else @click="handleShelves(scope.row.id)">下架</span>
            <span class="del" @click="handleDel(scope.row.id)">删除</span>
            <span class="view" @click="handlePreview(scope.row)">预览</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <Preview
      :visible="previewVisible"
      :selectId="currentCellId"
      @close="handleClosePreview"
    />
  </div>
</template>
<script>
import { getPersonalMadeList, deletePersonalMade, updatePersonalMadeUpAndDown } from '@/api/goods';
import Preview from '@/components/h5/customPage.vue';
import preview from '@/mixins/mobile';
import Pagination from '@/components/Pagination';
import UploadCustomize from '../components/UploadCustomize.vue';

export default {
  mixins: [preview],
  name: 'CustomList',
  data() {
    return {
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    Pagination,
    Preview,
    UploadCustomize,
  },
  mounted() {
    this.getPersonalMadeList();
  },
  methods: {
    getPersonalMadeList() {
      this.loading = true;
      getPersonalMadeList().then((res) => {
        if (res.success) {
          this.loading = false;
          this.tableData = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 添加商品
    handleAdd() {
      this.$router.push({ name: 'CustomAdd' });
    },
    // 上下架
    handleShelves(id) {
      updatePersonalMadeUpAndDown(id).then((res) => {
        if (res.success) {
          this.getPersonalMadeList();
          this.$message.success('操作成功');
        } else {
          this.$message.success(res.message);
        }
      });
    },
    // 删除
    handleDel(id) {
      deletePersonalMade(id).then((res) => {
        if (res.success) {
          this.getPersonalMadeList();
          this.$message.success('删除成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 编辑
    handleEditor(id) {
      this.$router.push({
        name: 'CustomEditor',
        query: {
          id,
        },
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content flex-end
.view, .del, .editor,.upShelves,.downShelves
  color #1890ff
  cursor pointer
.view, .del,.upShelves,.downShelves
  margin-right 20px
.memberImg
  width 150px
  height 100px
</style>
